module.exports = __webpack_public_path__ + "static/media/banner-grid-01.cd5920e5.jpg";